import { Component, inject, OnInit } from '@angular/core';
import { DriverApplicationFormComponent } from '../applications/driver-application-form/driver-application-form.component';
import { MatCardModule } from '@angular/material/card';
import { SeoService } from '@/app/core/seo/seo.service';

@Component({
    selector: 'admin-sidebar',
    imports: [
        DriverApplicationFormComponent,
        MatCardModule,
    ],
    host: {
        class: 'flex w-full flex-auto flex-col',
    },
    templateUrl: './root.component.html',
})
export class RootComponent implements OnInit {
    private seo = inject(SeoService);

    ngOnInit(): void {
        this.seo.setPage({
            title: 'CDL Truck Driving Jobs – One Application, Endless Opportunities',
            description: 'Apply once and get matched with trucking companies hiring CDL drivers. '
                + 'Find company driver, owner operator, and lease purchase jobs on Truck Drivers USA.',
            path: '/',
        });
    }
}
